import React from 'react';

const Products = () => {
    return (
        <div>
            <h4>This is products</h4>
        </div>
    );
};

export default Products;